"use client";

import WideImageTitle from "@/components/article/WideImageTitle";
import { LocationContext } from "@/components/framework/locationswitcher/locationReducer";
import { type LocationDocuments, type FrontPageArticles } from "@/sanity/types/frontPageArticles";
import { use, useMemo } from "react";
import styles from "./ArticleListSelector.module.css";
import { type FrontPageQueryResult } from "@/sanity/sanity.types";

//#region [Props]
type ArticleListSelectorProps = {
    commonArticles?: FrontPageArticles;
    locationDocuments?: LocationDocuments;
    imageMap: { [key: string]: string | undefined | null };
    locationArticles?: NonNullable<FrontPageQueryResult>["locationArticles"]
};
//#endregion

//#region [Component]
export default function ArticleListSelector({ commonArticles, locationDocuments, imageMap, locationArticles }: ArticleListSelectorProps) {
    const locationState = use(LocationContext);

    const articleList = useMemo(() => {
        if (locationState.selected.length === 0 || (locationDocuments?.length ?? 0) === 0) {
            return commonArticles;
        }

        const selectedTheaters = locationState.selected.map(th => th._id);
        const artIdsForSelectedLocs = locationDocuments!.filter(loc => selectedTheaters.includes(loc._id)).flatMap(loc => loc.articles).filter(art => !!art)?.map(art => art._id);
        if (artIdsForSelectedLocs.length === 0) {
            return commonArticles;
        }

        const artsForSelectedLocs = locationArticles?.filter(art => artIdsForSelectedLocs.includes(art._id)) ?? [];
        if (artIdsForSelectedLocs.length === 0) {
            return commonArticles;
        }
        return [...artsForSelectedLocs, ...(commonArticles ?? [])];

    }, [locationState, commonArticles, locationDocuments, locationArticles]);

    if ((articleList?.length ?? 0) === 0) {
        return null;
    }

    return <>
        {articleList?.map((art, idx) => <WideImageTitle key={`${idx}_${art?._id}`}
            article={art}
            className={styles[`Art_${idx}`] ?? styles.Art}
            imageRef={art?._type === "bygdekinoenFilmomtale" && !!art?.edi?.current ? imageMap[art.edi?.current] : undefined} />)}
    </>;
}
//#endregion

//#region [Styles]

//#endregion